import { Linkedin, Instagram, Facebook, Youtube, Twitter, Music } from "lucide-react";

export const THEMES = {
  classic_executive: { name: "Classico Elegante", bg: "#0F172A", surface: "#1E293B", text: "#F8FAFC", muted: "#94A3B8", border: "#334155" },
  minimal_white: { name: "Minimal Ceramica", bg: "#FFFFFF", surface: "#F1F5F9", text: "#0F172A", muted: "#64748B", border: "#E2E8F0" },
  emerald_gold: { name: "Smeraldo Lusso", bg: "#022C22", surface: "#064E3B", text: "#ECFDF5", muted: "#A7F3D0", border: "#065F46" },
  cyber_dark: { name: "Titanio Scuro", bg: "#09090B", surface: "#18181B", text: "#F4F4F5", muted: "#A1A1AA", border: "#27272A" },
};

export const ACCENTS = ["#2563EB", "#4F46E5", "#10B981", "#F59E0B", "#E11D48", "#06B6D4", "#F8FAFC"];

export const SOCIALS = [
  { key: "linkedin", label: "LinkedIn", icon: Linkedin },
  { key: "instagram", label: "Instagram", icon: Instagram },
  { key: "facebook", label: "Facebook", icon: Facebook },
  { key: "tiktok", label: "TikTok", icon: Music },
  { key: "x", label: "X / Twitter", icon: Twitter },
  { key: "youtube", label: "YouTube", icon: Youtube },
];

export const STATI_ATTIVITA = ["Attiva", "Inattiva", "Sospesa", "In liquidazione", "Cessata"];

export const formatDate = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

export const CAMERALI = [
  ["forma_giuridica", "Forma giuridica"], ["cf", "Codice fiscale"], ["stato_attivita", "Stato attività"],
  ["camera_commercio", "Camera di Commercio"], ["numero_rea", "Numero REA"], ["data_costituzione", "Data costituzione"],
  ["capitale_sociale", "Capitale sociale"], ["sede_legale", "Sede legale"], ["codice_ateco", "Codice ATECO"],
  ["settore_attivita", "Settore attività"], ["legale_rappresentante", "Legale rappresentante"],
];

export const normalizeUrl = (url) => (!url ? "" : /^https?:\/\//i.test(url) ? url : `https://${url}`);

export const publicUrl = (slug) => `${window.location.origin}/c/${slug}`;

const esc = (s = "") => s.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");

export function buildVCard(card) {
  const [first, ...rest] = (card.contact_name || "").split(" ");
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${esc(rest.join(" "))};${esc(first)};;;`,
    `FN:${esc(card.contact_name || card.company_name)}`,
    card.company_name && `ORG:${esc(card.company_name)}`,
    card.role && `TITLE:${esc(card.role)}`,
    card.phone && `TEL;TYPE=WORK,VOICE:${card.phone}`,
    card.whatsapp && `TEL;TYPE=CELL:${card.whatsapp}`,
    card.email && `EMAIL;TYPE=WORK:${card.email}`,
    card.pec && `EMAIL;TYPE=PEC:${card.pec}`,
    card.website && `URL:${normalizeUrl(card.website)}`,
    `URL;TYPE=Scheda:${publicUrl(card.slug)}`,
    card.address && `ADR;TYPE=WORK:;;${esc(card.address)};;;;`,
    card.piva && `NOTE:${esc(`P.IVA ${card.piva}`)}`,
    "END:VCARD",
  ];
  return lines.filter(Boolean).join("\r\n");
}

export function downloadVCard(card) {
  const blob = new Blob([buildVCard(card)], { type: "text/vcard;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${(card.company_name || card.slug).replace(/\s+/g, "_")}.vcf`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export const EMPTY_CARD = {
  slug: "", company_name: "", contact_name: "", role: "", piva: "", cf: "", description: "",
  forma_giuridica: "", stato_attivita: "Attiva", camera_commercio: "", numero_rea: "", data_costituzione: "",
  capitale_sociale: "", sede_legale: "", codice_ateco: "", settore_attivita: "", legale_rappresentante: "", pec: "",
  logo_path: "", cover_path: "", phone: "", email: "", whatsapp: "", address: "", hours: "", website: "",
  socials: { linkedin: "", instagram: "", facebook: "", tiktok: "", x: "", youtube: "" },
  links: [], theme: "classic_executive", accent: "#2563EB",
};
